import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContendorComponent } from './componentes/custom/contendor/contendor.component';
import { UserComponent } from './user.component';

const routes: Routes = [
  {
    path: "user", component: UserComponent, children:
      [
        {
          path: "dashboard", children: [
            { path: "perfil", component: ContendorComponent, pathMatch: 'full' },
            // { path: "entrega", component: ReporteEntregaComponent, pathMatch: 'full' },
          ]
        },
      ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
